import Vue from "vue";
import App from "./App.vue";
import router from "./router"; // before
import store from "./store";
import Moment from "moment";
import scroll from "vue-seamless-scroll";

import {
    getDicts
} from "@/api/system/dict/data";
// 字典标签组件
import DictTag from "@/components/DictTag";
// 字典数据组件
import DictData from "@/components/DictData";
/*element-ui*/
import ElementUI from "element-ui";
import("element-ui/lib/theme-chalk/index.css");
import "@/assets/css/common.css";
import _ from "lodash";
import plugins from "./plugins"; // plugins
import VueQriously from "vue-qriously";
import Meta from 'vue-meta'
Vue.config.productionTip = false;
//全局方法挂载
Vue.prototype.getDicts = getDicts;
Vue.prototype.moment = Moment;

Vue.prototype.$_ = _;
Vue.prototype._ = _;
Vue.prototype.topScroll = function() {
    if (window.scrollY == 0) {
        return;
    }
    var i = 1500;
    let time = setInterval(() => {
        window.scrollTo({
            top: (i -= 15),
            left: 0,
        });
        if (i == 0) {
            clearInterval(time);
        }
    });
};
Vue.component("DictTag", DictTag);
DictData.install();
Vue.use(ElementUI);
Vue.use(plugins);
Vue.use(scroll);
Vue.use(VueQriously);
Vue.use(Meta)
new Vue({
    metaInfo: {
        title: '三峡游轮联网售票中心官网-全国预订热线:400-666-2219',
        meta: [{
                name: 'keywords',
                content: '游三峡,三峡游,三峡旅游,三峡船票,三峡游船价格,三峡游轮,三峡豪华游轮,长江三峡游轮,三峡游船,三峡游轮旅游攻略,长江三峡旅游,重庆三峡游轮'
            },
            {
                name: 'description',
                content: '【长江三峡游轮联网售票中心官网】提供三峡游轮船票预定,重庆到宜昌,重庆到武汉,重庆到南京,重庆到上海,万州到宜昌航线及世纪游轮,黄金游轮,总统游轮,美国维多利亚游轮,华夏神女游轮,长江海外游轮,长江一号,长江二号,长江探索号船票,为您提供三峡游轮旅游最美航线,超低价格,尽你优选热线400-222-2219'
            }
        ]
    },
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");